module.exports = __webpack_public_path__ + "img/icon_hutong@2x.c041f37a.png";